/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import {
  db,
  firebase,
  storage,
  sendDynamicEmail,
  sendSMS,
} from 'firebase/fbConfig.js';
import { connect } from 'react-redux';
import axios from 'axios';
import compose from 'recompose/compose';
import _ from 'lodash';
import moment from 'moment';
import { v1 as uuidv1 } from 'uuid';
import jsPDF from 'jspdf';

import DateTimePicker from 'react-datetime-picker';

// react component for creating dynamic tables
import ReactTable from 'react-table';

// @material-ui core components
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';
import Snackbar from '@material-ui/core/Snackbar';
import Switch from '@material-ui/core/Switch';
import Divider from '@material-ui/core/Divider';

// @material-ui icons
import Check from '@material-ui/icons/Check';

// @material-ui lab
import MuiAlert from '@material-ui/lab/Alert';

import Style from 'assets/jss/material-dashboard-pro-react/views/actionsStyle';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import UserConfirmModal from 'components/Modal/UserConfirm.jsx';
import TripVendorForm from 'components/Forms/TripVendorForm';
import Slide from '@material-ui/core/Slide';
import OrderCard from './OrderCard.jsx';

import PrototypeExploreAssignUser from 'views/Explore/PrototypeExploreAssignUser.jsx';

// Table Data
import columns from 'tables/columns/orders.json';
import { getTripOrders, formatOrders } from 'tables/rows/orders';

import { createBOL, createRateCon } from 'store/actions/documentActions';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
} 

const INITIAL_STATE = {
  tripNumber: null,
  ordersData: null,
  dataLoaded: false,
  selectedOrders: [],
  vendorRemoved: null,
  vendorSelected: '',
  vendorsData: [],
  driverSelected: '',
  driversData: [],
  description: '',
  truckType: '',
  trailerType: '',
  tripType: '',
  entityQuery: '',
  estimatedDeparture: null,
  pickUpLocation: null,
  dropOffLocation: null,
  tripRate: 0,
  pickUpBy: null,
  dropOffBy: null,
  groupIDs: null,
  documentsLoading: 0,
  documentsLoaded: 0,
  isPickUp: false,
  isDropOff: false,
  snackInfo: {
    open: false,
  },
};

class TripBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.state.isClicked = false;
  }

  componentDidMount() {
    console.log('mount component');
    console.log(this.props, this.state);

    this.getOrders();

    this.loadVendorData();
    if (this.props.trip) {
      const changeState = {};

      if (this.props.trip.vendorName) {
        changeState.vendorSelected = this.props.trip.vendorName;
      }
      if (this.props.trip.driverName) {
        changeState.driverSelected = this.props.trip.driverName;
      }

      const tripMergeKeys = [
        'pickUpLocation',
        'dropOffLocation',
        'tripRate',
        'pickUpBy',
        'dropOffBy',
        'status',
        'rateConURL',
        'rateConHash',
        'tripNumber',
        'groupIDs',
        'description',
        'additionalTI',
        'truckType',
        'trailerType',
        'tripType',
        'startDate',
        'endDate',
        'tripStartLocation',
        'tripEndLocation',
        'estimatedDeparture',
        'esignEnabled',
        'esignEnabledBOL'
      ];
      tripMergeKeys.map((key) => {
        if (this.props.trip[key] && this.props.trip[key].seconds) {
          changeState[key] = this.props.trip[key].toDate();
        } else if (this.props.trip[key]) {
          changeState[key] = this.props.trip[key];
        }
      });

      if (Object.keys(changeState).length) this.setState(changeState);

      if (this.props.trip.pickUpLocation) {
        this.setState({
          isPickUp: true,
        });
      }
      if (this.props.trip.dropOffLocation) {
        this.setState({
          isDropOff: true,
        });
      }
    }
  }

  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState(
      {
        [id]: value,
      },
      () =>
        id === 'tripRate' &&
        !this.state.rateConURL &&
        !this.state.rateConHash &&
        this.refreshOrderRates()
    );
  };

  handleDateTimeChange = (date, id) => {
    this.setState({
      [id]: date,
    });
  };

  handleSwitchChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });

    // console.log('jelly', this.state);
  };

  handleClearTripAlternate = (name) => {
    const { pickUpLocation, dropOffLocation } = this.state;
    // console.log('kingFish', name);
    if (name === 'pickUp') {
      this.setState({
        pickUpLocation: false,
      });
    }
    if (name === 'dropOff') {
      this.setState({
        dropOffLocation: false,
      });
    }
  };

  handleChangeLocation = (e, name) => {
    const { id, value } = e.target;
    this.setState((prevState) => {
      // console.log('prevState', prevState);
      const locationObj = prevState[`${name}Location`]
        ? prevState[`${name}Location`]
        : {};
      locationObj[id] = value;
      prevState[`${name}Location`] = locationObj;
      const filledEntries = Object.entries(prevState[`${name}Location`]).filter(
        (arr) => arr[1]
      );
      const keys = filledEntries.map((entry) => entry[0]);
      if (
        !filledEntries.length ||
        keys.every((key) => ['entityName', 'entityID'].includes(key))
      )
        prevState[`${name}Location`] = null;
      // console.log('PrevState2', prevState);
      return prevState;
    });
    // console.log('TRIPALT', this.state);
  };

  handleChangeLegType = (e, i) => {
    e.stopPropagation();
    const { id, value } = e.target;
    const { selectedOrders, legType } = this.state;

    selectedOrders[i].legType = value;

    this.setState({
      selectedOrders,
    });
  };

  handleSwitchChangeOrder = (name, id) => (event) => {
    const { selectedOrders } = this.state;

    selectedOrders[id][name]
      ? (selectedOrders[id][name] = false)
      : (selectedOrders[id][name] = true);

    this.setState({
      selectedOrders,
    });
  };

  handleDepartureTimeChange = (date) => {
    console.log(date);
    this.setState({ estimatedDeparture: date });
  }

  handleDateTimeTripOrderPickUpChange = (date, i) => {
    // const { value } = e.target;
    // console.log(date);
    // console.log(i);

    const { selectedOrders } = this.state;
    selectedOrders[i].pickUpBy = date;

    this.setState({
      selectedOrders,
    });
  };

  handleClearPickUp = (i) => {
    const { selectedOrders } = this.state;
    selectedOrders[i].pickUpLocation = '';
    selectedOrders[i].isPickUp = false;
    selectedOrders[i].pickUpBy = '';
    this.setState({
      selectedOrders,
    });
    // console.log(this.state.selectedOrders);
  };

  handleClearDropOff = (i) => {
    const { selectedOrders } = this.state;
    selectedOrders[i].dropOffLocation = '';
    selectedOrders[i].isDropOff = false;
    selectedOrders[i].dropOffBy = '';
    this.setState({
      selectedOrders,
    });
  };

  handleDateTimeTripOrderDropOffChange = (date, i) => {
    // const { value } = e.target;
    // console.log(date);
    // console.log(i);

    const { selectedOrders } = this.state;
    selectedOrders[i].dropOffBy = date;

    this.setState({
      selectedOrders,
    });
  };

  handleChangeTripOrderPickUpLocation = (e, i) => {
    const { id, value } = e.target;
    // console.log(id);
    // console.log(value);
    // console.log(i);

    const { selectedOrders } = this.state;
    selectedOrders[i].pickUpLocation = this.state.selectedOrders[i]
      .pickUpLocation
      ? { ...this.state.selectedOrders[i].pickUpLocation }
      : {};
    selectedOrders[i].pickUpLocation[id] = value;

    this.setState({
      selectedOrders,
    });
  };

  handleChangeTripOrderDropOffLocation = (e, i) => {
    const { id, value } = e.target;
    // console.log(id);
    // console.log(value);
    // console.log(i);

    const { selectedOrders } = this.state;
    selectedOrders[i].dropOffLocation = this.state.selectedOrders[i]
      .dropOffLocation
      ? { ...this.state.selectedOrders[i].dropOffLocation }
      : {};
    selectedOrders[i].dropOffLocation[id] = value;

    this.setState({
      selectedOrders,
    });
  };

  handleChangeRate = (e, i) => {
    e.stopPropagation();
    const { id, value } = e.target;
    const { selectedOrders, tripRate } = this.state;

    const rateType = id.split('-')[0];
    let rate = 0;

    switch (rateType) {
      case '%':
        rate = parseFloat(value) * 0.01 * parseFloat(tripRate);
        break;
      default:
        rate = parseFloat(value);
        break;
    }

    selectedOrders[i].rate = rate;

    this.setState(
      {
        selectedOrders,
      },
      () => this.calculateUnallocated()
    );
  };

  getOrders = (limited = true) => {
    getTripOrders(this.props.authUser.uid, limited)
      .then(this.loadOrderData)
  }

  refreshOrderRates = () => {
    this.setState((prevState) => {
      prevState.selectedOrders = prevState.selectedOrders.map(
        (order, i, self) => {
          order.rate = parseFloat(prevState.tripRate) / self.length;
          return order;
        }
      );
      prevState.rateUnallocated = 0;
      return prevState;
    });
  };

  calculateUnallocated = () => {
    const { selectedOrders, tripRate } = this.state;

    const rates = selectedOrders.map((order, i, self) =>
      order.rate ? order.rate : parseFloat(tripRate) / self.length
    );
    const ratesAdded = rates.reduce(
      (accumulator, currentValue) =>
        parseFloat(accumulator) + parseFloat(currentValue)
    );

    const remaining = parseFloat(this.state.tripRate) - ratesAdded;
    // console.log("rates: "+rates, ratesAdded)
    this.setState({
      rateUnallocated: remaining,
    });
  };

  rearrangeSelectedOrders = (value, i, e) => {
    e.stopPropagation();
    const { selectedOrders } = this.state;
    const temp = selectedOrders.splice(i, 1);

    selectedOrders.splice(i + value, 0, temp[0]);

    this.setState({ selectedOrders });
  };

  closeSnack = (snack) => {
    this.setState((prevState) => (prevState.snackInfo.open = false));
  };

  closeModal = (id) => {
    this.setState({ [id]: false });
  };

  handleSelectChange = (e, i) => {
    console.log(e, i);
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (value && name === 'vendorSelected') {
        this.loadDriverData();
      }
    });
    if (name === 'driverSelected') {
      const driver = this.state.driversData.find((d) => d.name === value);
      this.setState({
        driverId: driver.id,
      });
    }
  };

  handleVendorChange = (e, i) => {
    console.log(e, i);
    const { name, value } = e.target;

    const changes = {};

    if (this.props.trip) {
      const prevVendor = this.state.vendorsData.find(
        (v) => v.name === this.state.vendorSelected
      );
      const newVendor = this.state.vendorsData.find((v) => v.name === value);
      if (
        !this.state.vendorRemoved &&
        prevVendor &&
        newVendor &&
        prevVendor.id !== newVendor.id
      ) {
        changes.vendorRemoved = prevVendor;
        changes.vendorId = newVendor.id;
      }
    }

    changes[name] = value;

    this.setState(changes, () => {
      this.loadDriverData();
    });
    const vendor = this.state.vendorsData.find((v) => v.name === value);
    this.setState({
      vendorId: vendor.id,
    });
  };

  generateBOL = (order, i) => new Promise((resolve, reject) => {
    console.log('creating bol')
    createBOL(order, this.state.vendorSelected, this.state.esignEnabledBOL)
      .then(data => {
        console.log('evergrande completed', data);
        if (!data.error) {
          console.log('evergrande successful');
          this.setState((prevState) => (prevState.documentsLoaded += 1));
          resolve({
            urls: {
              signingURLs: [
                this.state.esignEnabledBOL ? data.signers[0].embedded_signing_url : "",
                this.state.esignEnabledBOL ? data.signers[1].embedded_signing_url : "",
                this.state.esignEnabledBOL ? data.signers[2].embedded_signing_url : "",
              ],
            },
            hashes: {
              bolHash: this.state.esignEnabledBOL ? data.document_hash : "",
              bolHashURL: this.state.esignEnabledBOL ? `https://api.eversign.com/api/download_current_document_status?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${data.document_hash}&audit_trail=1` : data.fileURL,
            },
            fileURL: data.fileURL,
            regenerated: true,
            freightBillNumber: order.freightBillNumber,
            stop: Number(i) + 1,
          });
        } else {
          console.log('error w/ evergrande');
          this.setState({
            snackInfo: {
              open: true,
              severity: 'error',
              message: data.error
                ? data.error.info
                  ? data.error.info
                  : data.error.type
                : 'Unknown error',
            },
          });
          reject(data.error);
        }
      })
  });

  generateRateCon = (orders) => new Promise((resolve, reject) => {
    createRateCon({
      tripType: this.state.tripType,
      tripNumber: this.state.tripNumber,
      additionalTI: this.state.additionalTI,
      driver: this.state.driversData.find(driver => driver.name === this.state.driverSelected),
      driverSelected: this.state.driverSelected,
      tripRate: this.state.tripRate,
      isPickUp: this.state.isPickUp,
      isDropOff: this.state.isDropOff,
      pickUpLocation: this.state.pickUpLocation,
      dropOffLocation: this.state.dropOffLocation,
      pickUpBy: this.state.pickUpBy,
      dropOffBy: this.state.dropOffBy,
      tripID: this.props.tripID,
      esignEnabled: this.state.esignEnabled
    }, orders)
      .then(data => {
        console.log('evergrande completed', data);
        if (!data.error) {
          console.log('evergrande successful');
          this.setState((prevState) => (prevState.documentsLoaded += 1));
          resolve({
            fileURL: this.state.esignEnabled ? data.signers[0].embedded_signing_url : data.fileURL,
            hash: this.state.esignEnabled ? data.document_hash : "",
            id: this.state.esignEnabled ? data.fileID : "",
            createdAt: new Date(),
            name: 'Rate Con',
          });
        } else {
          console.log('error w/ evergrande');
          this.setState({
            snackInfo: {
              open: true,
              severity: 'error',
              message:
                'Could not generate rate con, please refresh and try again. If problem persists, contact the system administrator.',
            },
          });
          reject(data.error);
        }
      })
  });

  rowFromOrder = (order) => ({
    id: order.id,
    billingParty: order.billingParty ? order.billingParty : '',
    freightBillNumber: order.freightBillNumber
      ? order.freightBillNumber
      : 'N/A',
    originBusinessName: order.origin.businessName
      ? order.origin.businessName
      : '',
    originCity:
      order.origin.city && order.origin.state
        ? order.origin.city + ', ' + order.origin.state
        : '',
    originState: order.originState ? order.originState : '',
    destinationBusinessName: order.destination.businessName
      ? order.destination.businessName
      : '',
    destinationCity:
      order.destination.city && order.destination.state
        ? order.destination.city + ', ' + order.destination.state
        : '',
    destinationState: order.destinationState
      ? order.destinationState
      : '',
    uid: order.uid ? order.uid : 'N/A',
    totalRevenue: order.totalRevenue ? order.totalRevenue : 0,
    totalExpenses: order.totalExpenses ? order.totalExpenses : 0,
    deliveryType: order.deliveryType ? order.deliveryType : 'N/A',
    origin: order.origin ? order.origin : null,
    pickUpDate: order.origin.date
      ? moment(order.origin.date.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    destination: order.destination ? order.destination : null,
    dropOffDate: order.destination.date
      ? moment(order.destination.date.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    class: order.class ? order.class : 'N/A',
    submitted: order.updatedAt
      ? moment(order.updatedAt.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    status: order.status ? order.status : 'N/A',
    financialStatus: order.financialStatus
      ? order.financialStatus
      : 'N/A',
    tripRateStatus: order.tripRateStatus
      ? order.tripRateStatus
      : 'N/A',
    dropOffRateStatus: order.dropOffRateStatus
      ? order.dropOffRateStatus
      : 'N/A',
    updatedAt: order.updatedAt
      ? moment(order.updatedAt.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    serviceETA: order.serviceETA
      ? moment(order.serviceETA.toDate()).format('YYYY-MM-DD HH:mm')
      : 'N/A',
    entityIDs: order.entityIDs ? order.entityIDs : [],
    vendorName:
      order.vendorPickUp && order.vendorPickUp.name
        ? order.vendorPickUp.name
        : 'N/A',
    driverName:
      order.pickUpDriver && order.pickUpDriver.firstName
        ? `${order.pickUpDriver.firstName}${order.pickUpDriver.lastName
          ? ` ${order.pickUpDriver.lastName}`
          : ''
        }`
        : 'N/A',
    signingURLs: order.signingURLs ? order.signingURLs : [],
    bolHash: order.bolHash ? order.bolHash : [],
    groups: order.groups ? order.groups : null,
  })

  rowFromID = (id) => new Promise((resolve, reject) => {
    const orderRef = db.collection('haney-orders').doc(id);
    orderRef.get().then((snap) => {
      const docData = {
        ...snap.data(),
        id: snap.id,
      };

      const res = this.rowFromOrder(docData);

      // console.log(docData);

      if (res.totalExpenses) {
        orderRef
          .collection('register')
          .get()
          .then((snapshot) => {
            const registerData = snapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));

            const totalExpensesArr = registerData.filter(
              (r) =>
                r.tripNumber !== this.state.tripNumber &&
                r.category === 'expense'
            );

            // console.log(totalExpensesArr);

            let totalOrderExpenses = 0;

            totalExpensesArr.map(
              (expense) => (totalOrderExpenses += expense.dollarAmount)
            );

            // res.totalExpenses = totalExpensesArr.length
            //   ? totalExpensesArr.reduce(
            //       (accumulator, currentValue) =>
            //       parseFloat(accumulator) + parseFloat(currentValue.dollarAmount)
            //       )
            //   : 0;

            res.totalExpenses = totalOrderExpenses;

            // console.log(totalOrderExpenses);
            // console.log(res);

            resolve([res, docData]);
          });
      } else {
        resolve([res, docData]);
      }
    });
  });

  separateOrders = async (orders) => {
    const { trip, selectedOrders } = this.props;

    const TableAction = ({ order }) => (
      <Button
        color="primary"
        fullWidth
        onClick={() =>
          order.signingURLs && order.signingURLs.length
            ? this.promptUser(order)
            : this.addToTrip(order, true)
        }
      >
        ADD
      </Button>
    );

    orders = orders.map(order => ({
      ...order,
      actions: <TableAction order={order} />
    }))

    if (selectedOrders) {
      const formattedOrders = selectedOrders.map(order => ({
        ...order,
        actions: <TableAction order={order} />
      }));

      return [
        [
          ...orders,
          ...formattedOrders
        ],
        []
      ];
    } else if (trip && trip.orders) {
      const snapshots = await Promise.all(trip.orders.map((order) => db.collection('haney-orders').doc(order.orderID).get()));
      const formattedData = await formatOrders({
        docs: snapshots
      });
      const selectedToRows = [];
      const savedOrdersData = [];
      formattedData.map(order => ({
        ...order,
        actions: <TableAction order={order} />
      })).map((data, i) => {
        selectedToRows.push({
          ...data,
          generateBOL: trip.orders[i].generateBOL,
          rate: trip.orders[i].rate,
        });
        savedOrdersData.push(data);
      });
      const filteredOrders = orders.filter((order) =>
        selectedToRows.find((row) => row.id === order.id) ? false : true
      );

      this.setState({
        savedOrdersData: snapshots.map(doc => ({ id: doc.id, ...doc.data() }))
      });

      return [
        filteredOrders,
        selectedToRows
      ];
    } else {

      return [
        orders,
        []
      ];
    }
  };

  loadOrderData = async (orders, promptUser = true) => {
    // console.log('Orderdata loading:');
    // console.log(orders);
    const [dataRows, selectedDataRows] = await this.separateOrders(
      orders
    );

    // console.log(dataRows, selectedDataRows);

    this.setState(
      {
        ordersData: dataRows,
        ordersDataRef: dataRows,
        selectedOrders: selectedDataRows,
        dataLoaded: true,
      },
      () => {
        if (this.props.selectedOrders) {
          const [order] = this.props.selectedOrders;
          if (promptUser && order.signingURLs && order.signingURLs.length) {
            this.promptUser(this.props.selectedOrders[0]);
          } else {
            const selectedOrder = dataRows.find((o) => o.id === order.id);
            if (selectedOrder) this.addToTrip(selectedOrder, true);
          }
        }

        if (this.state.isPickUp && this.state.selectedOrders.length) {
          const pickUpLocation = this.state.selectedOrders[0].pickUpLocation;
          if (pickUpLocation) {
            this.setState({
              tripStartLocation: String(
                pickUpLocation.businessName +
                ' ' +
                pickUpLocation.address +
                ' ' +
                pickUpLocation.city +
                ' ' +
                pickUpLocation.state +
                ' ' +
                pickUpLocation.zip
              ),
            });
          }
        }
        if (!this.state.isPickUp) {
          if (this.state.selectedOrders.length) {
            const pickupLocation = this.state.selectedOrders[0].origin;
            if (pickupLocation) {
              this.setState({
                tripStartLocation: String(
                  pickupLocation.businessName +
                  ' ' +
                  pickupLocation.address +
                  ' ' +
                  pickupLocation.city +
                  ' ' +
                  pickupLocation.state +
                  ' ' +
                  pickupLocation.zip
                ),
              });
            }
          } else
            this.setState({
              tripStartLocation: '',
            });
        }

        if (this.state.isDropOff && this.state.selectedOrders.length) {
          const dropOffLocation = this.state.selectedOrders[
            this.state.selectedOrders.length - 1
          ].dropOffLocation;
          if (dropOffLocation) {
            this.setState({
              tripEndLocation: String(
                dropOffLocation.businessName +
                ' ' +
                dropOffLocation.address +
                ' ' +
                dropOffLocation.city +
                ' ' +
                dropOffLocation.state +
                ' ' +
                dropOffLocation.zip
              ),
            });
          }
        }
        if (!this.state.isDropOff) {
          if (this.state.selectedOrders.length >= 1) {
            const dropOffLocation = this.state.selectedOrders[
              this.state.selectedOrders.length - 1
            ].destination;
            if (dropOffLocation) {
              this.setState({
                tripEndLocation: String(
                  dropOffLocation.businessName +
                  ' ' +
                  dropOffLocation.address +
                  ' ' +
                  dropOffLocation.city +
                  ' ' +
                  dropOffLocation.state +
                  ' ' +
                  dropOffLocation.zip
                ),
              });
            }
          } else {
            this.setState({
              tripEndLocation: '',
            });
          }
        }
      }
    );
    // console.log('point88', this.props);
  };

  loadVendorData = () => {
    db.collection('haney-vendors')
      .get()
      .then((snap) => {
        const vendorsData = snap.docs
          .map((doc) => {
            const docData = {
              ...doc.data(),
              id: doc.id,
            };
            if (
              ['Ground Carrier', 'LTL Carrier', 'Broker'].includes(
                docData.vendorType
              ) &&
              docData.marketAreas &&
              docData.marketAreas.length
            ) {
              // docData.name = `${docData.name}`
              return docData;
            }

            return null;
          })
          .filter(Boolean)
          .sort((a, b) => {
            const aName = a.name.toUpperCase();
            const bName = b.name.toUpperCase();

            if (aName > bName) return 1;
            if (aName < bName) return -1;
            return 0;
          });

        let filteredVendorsData = vendorsData.sort((a, b) => {
          return a.name - b.name;
        });

        this.setState({ vendorsData }, () => {
          if (this.props.trip) {
            this.loadDriverData();
          }
        });
      });
  };

  loadDriverData = () => {
    // console.log(this.state.vendorsData);
    const vendor = this.state.vendorsData.find(
      (vendor) => vendor.name === this.state.vendorSelected
    );

    if (vendor) {
      db.collection('haney-vendors')
        .doc(vendor.id)
        .collection('users')
        .where('role', '==', 'Driver')
        .get()
        .then((snap) => {
          const driversData = snap.docs
            .map((doc) => ({
              ...doc.data(),
              id: doc.id,
            }))
            .sort((a, b) => {
              const aName = a.name.toUpperCase();
              const bName = b.name.toUpperCase();

              if (aName > bName) return 1;
              if (aName < bName) return -1;
              return 0;
            });
          this.setState({
            driversData,
          });
        });
    }
  };

  promptUser = (order) => {
    this.setState((prevState) => {
      prevState.promptModal = true;
      // console.log(
      //   prevState,
      //   order,
      //   prevState.ordersData.findIndex((o) => o.id === order.id)
      // );
      prevState.selectedOrder = order
      return prevState;
    });
  };

  promptUserDelete = (order) => {
    // console.log(order.id, this.state.ordersData.findIndex(o => o.id === order.id));
    this.setState(prev => ({
      ...prev,
      promptDeleteModal: true,
      selectedOrder: order
    }))
  }

  checkRegister = async (order) => {
    // console.log('register check', order);
    const register = await db.collection('haney-orders').doc(order.id).collection('register').where('tripNumber', '==', this.props.trip.tripNumber).get()
    // console.log('register', register);
    if (!register.empty) return register.docs.map(doc => ({
      ...doc.data(),
      id: doc.id
    }))
    else return false;
  }

  uploadFile = (refString, file) => {
    // console.log('Uploading image');
    return new Promise((resolve, reject) => {
      // create storage ref
      var storageRef = storage.ref(refString);
      // upload file64
      var uploadTask = storageRef.put(file);
      // update progress bar
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var Progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.setState({
            uploadProgress: 'Progress is ' + Progress + '% done',
          });

          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              this.setState({ uploadProgress: ' Upload is paused' });
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              this.setState({ uploadProgress: 'Upload is running' });
              break;
          }
        },
        (error) => {
          // Handle unsuccessful uploads
          console.log(error);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      );
    });
  };

  switchArrays = (arr1, arr2, key) => {
    const index = arr1.findIndex((data) => data[key.name] === key.value);
    arr2.push(arr1[index]);
    arr1.splice(index, 1);
    return [arr1, arr2];
  };

  addToTrip = (order, needsBOL) => {
    // console.log('Adding to trip', order, this.state.selectedOrders);

    const [ordersData, selectedOrders] = this.switchArrays(
      this.state.ordersData,
      this.state.selectedOrders,
      { name: 'id', value: order.id }
    );
    // console.log('Switched arrays', selectedOrders, order);
    selectedOrders[selectedOrders.length - 1].generateBOL = needsBOL;

    // console.log('Set generateBOL bool');
    this.setState(
      {
        selectedOrders: [...selectedOrders],
        ordersData: [...ordersData],
      },
      () => {
        // console.log('Successfully added to trip');
        if (this.props.trip) {
          this.save(this.props.tripID);
        }
      }
    );
  };

  checkRemoveOrder = async (e, order) => {
    e.stopPropagation();

    const register = await this.checkRegister(order);
    // console.log('register', register);
    if (register) {
      this.promptUserDelete(order);
    } else {
      this.removeFromTrip(order);
    }
  }

  removeFromTrip = async (order) => {
    const register = await this.checkRegister(order);
    if (register) {
      await Promise.all(register.map(r => db.collection('haney-orders').doc(order.id).collection('register').doc(r.id).delete()))
    }

    const [selectedOrders, ordersData] = this.switchArrays(
      this.state.selectedOrders,
      this.state.ordersData,
      { name: 'id', value: order.id }
    );
    ordersData.sort((a, b) =>
      parseInt(a.freightBillNumber) < parseInt(b.freightBillNumber) ? 1 : -1
    );
    this.setState(
      {
        selectedOrders: [...selectedOrders],
        ordersData: [...ordersData],
      },
      () => {
        if (this.props.trip) {
          this.save(this.props.tripID);
        }
      }
    );
  };

  getSelectedData = () => new Promise(async (resolve, reject) => {
    const { selectedOrders, savedOrdersData: tempData } = this.state;
    console.log('Artemis', selectedOrders);
    const orderRefs = []; // to be used for promises
    const toRemove = []; // store indexes to remove from savedOrdersData

    const savedOrdersData = tempData ? tempData : [];

    const noExcessSaved = savedOrdersData.every((order) =>
      selectedOrders.find((o) => o.id === order.id)
    ); // check to see if any orders were removed from the selectedOrders array
    const noOrdersAdded = selectedOrders.every((order) =>
      savedOrdersData.find((o) => o.id === order.id)
    ); // check to see if any orders were added to the selectedOrders array

    // Looping through savedOrders and selectedOrders (if orders have changed since page load) to determine what order data must be gotten, what already exists, and what order data has been deleted.
    const loopLen =
      noExcessSaved && noOrdersAdded
        ? 0
        : Math.max(savedOrdersData.length, selectedOrders.length);
    for (let i = 0; i < loopLen; i++) {
      if (i < savedOrdersData.length) {
        const index = selectedOrders.findIndex(
          (saved) => saved.id === savedOrdersData[i].id
        );
        if (index === -1) {
          toRemove.push(i);
        }
      }

      if (i < selectedOrders.length) {
        const index = savedOrdersData.findIndex(
          (saved) => saved.id === selectedOrders[i].id
        );
        if (index === -1) {
          orderRefs.push(
            db.collection('haney-orders').doc(selectedOrders[i].id)
          );
        }
      }
    }

    toRemove.map((s, i) => savedOrdersData.splice(s - i, 1)); // Clears all the data from savedOrders that was deleted from selectedOrders with indexes created in loop above

    // Get all order data that doesn't already exist
    const newOrderSnaps = await Promise.all(
      orderRefs.map((ref) => ref.get())
    );
    const newOrdersData = newOrderSnaps.map((snap) => ({
      ...snap.data(),
      id: snap.id,
    }));

    const allOrdersData = [...savedOrdersData, ...newOrdersData];


    this.setState({ savedOrdersData: allOrdersData }, () =>
      resolve(allOrdersData)
    );
  });

  save = (docID) => new Promise(async (resolve, reject) => {
    const {
      selectedOrders,
      pickUpLocation,
      dropOffLocation,
      pickUpBy,
      dropOffBy,
      tripRate,
      tripNumber: count,
      alternateAddress,
      description,
      trailerType,
      truckType,
      tripType,
      startDate,
      endDate,
      tripStartLocation,
      tripEndLocation,
      esignEnabled,
      esignEnabledBOL
    } = this.state;
    // console.log('===', selectedOrders);
    // const vendorSelected = this.state.vendorSelected ? this.state.vendorSelected : ((this.props.trip && this.props.trip.vendorName) ? this.props.trip.vendorName : '');
    const vendor = this.state.vendorsData.find(
      (vendor) => vendor.name === this.state.vendorSelected
    );

    const driver = this.state.driversData.find(
      (driver) => driver.name === this.state.driverSelected
    );

    console.log("driver: " + driver)

    const otherChanges = {};
    if (vendor) {
      otherChanges.vendorName = vendor.name;
      otherChanges.vendorId = vendor.id;
    }
    if (driver) {
      otherChanges.driverName = driver.name;
      otherChanges.driverID = driver.id;
      otherChanges.driverTruckNumber = driver.truckNumber ? driver.truckNumber : "";
    }

    const tripNumber = count ? count : await this.newTripNumber();
    console.log('tripNumber', count);
    const allSelectedData = await this.getSelectedData();
    console.log('FirstTime');

    const groups = {};
    allSelectedData.map((d) => {
      if (d.groups && d.groups.length) {
        d.groups.map((group) => {
          if (!groups[group]) groups[group] = true;
        });
      }
    });

    const groupIDs = Object.keys(groups);

    const promises = [];

    // if (this.state.vendorRemoved) {
    //   promises.push(
    //     db
    //       .collection('haney-vendors')
    //       .doc(this.state.vendorRemoved.id)
    //       .collection('haney-trips')
    //       .doc(docID)
    //       .delete()
    //   );
    // }

    this.setState({ groupIDs });
    const [firstOrder, lastOrder] = [
      selectedOrders[0],
      selectedOrders[selectedOrders.length - 1],
    ];
    console.log(selectedOrders);
    console.log('Hitting save func!!!');
    Promise.all([
      // db
      // .collection('haney-vendors')
      // .doc(vendor.id)
      db
        .collection('haneyTrips')
        .doc(docID)
        .set({
          id: docID ? docID : null,
          orders: selectedOrders.map((order, i, self) => ({
            orderID: order.id,
            isPickUp: order.isPickUp ? order.isPickUp : '',
            isDropOff: order.isDropOff ? order.isDropOff : '',
            legType: order.legType ? order.legType : '',
            freightBillNumber: order.freightBillNumber ? order.freightBillNumber : '',
            dropOffCityState: order.destinationCity ? order.destinationCity : '',
            pickUpCityState: order.originCity ? order.originCity : '',
            pickpShipperName: order.originBusinessName ? order.originBusinessName : '',
            pickUpShipperID: order.entityIDs[0] ? order.entityIDs[0] : '',
            dropOffShipperName: order.destinationBusinessName ? order.destinationBusinessName : '',
            dropOffShipperID: order.entityIDs[1] ? order.entityIDs[1] : '',
            pickUpBy: order.pickUpBy ? order.pickUpBy : null,
            pickUpLocation: order.pickUpLocation ? order.pickUpLocation : null,
            dropOffBy: order.dropOffBy ? order.dropOffBy : null,
            dropOffLocation: order.dropOffLocation ? order.dropOffLocation : null,
            generateBOL: order.generateBOL,
            rate: order.rate ? order.rate : parseFloat(this.state.tripRate) / self.length,
            totalRevenue: order.totalRevenue ? order.totalRevenue : 0,
            totalExpenses: order.totalExpenses ? order.totalExpenses : 0
          })),
          orderIDs: Object.fromEntries(selectedOrders.map(order => [order.id, true])),
          freightBillNumbers: selectedOrders.map((order) => order.freightBillNumber).join(', '),
          pickUpShipperName: selectedOrders.length ? selectedOrders[0].originBusinessName : null,
          dropOffShipperName: selectedOrders.length ? selectedOrders[selectedOrders.length - 1].destinationBusinessName : null,
          pickUpShipperCity: selectedOrders.length ? selectedOrders[0].originCity : null,
          dropOffShipperCity: selectedOrders.length ? selectedOrders[selectedOrders.length - 1].destinationCity : null,
          pickUpLocation: pickUpLocation ? pickUpLocation : null,
          dropOffLocation: dropOffLocation ? dropOffLocation : null,
          tablePickupLocation: this.state.tripStartLocation ? this.state.tripStartLocation : '',
          tableDropOffLocation: this.state.tripEndLocation ? this.state.tripEndLocation : '',
          ...otherChanges,
          isPickUp: this.state.isPickUp ? this.state.isPickUp : null,
          isDropOff: this.state.isDropOff ? this.state.isDropOff : null,
          tripRate: this.state.tripRate,
          description,
          additionalTI: this.state.additionalTI ? this.state.additionalTI : '',
          trailerType,
          truckType: this.state.truckType ? this.state.truckType : '',
          tripType,
          pickUpBy: this.state.pickUpBy ? this.state.pickUpBy : '',
          dropOffBy: this.state.dropOffBy ? this.state.dropOffBy : '',
          status: this.state.status ? this.state.status : '',
          rateConURL: this.state.rateConURL ? this.state.rateConURL : '',
          rateConHash: this.state.rateConHash ? this.state.rateConHash : '',
          tripNumber: tripNumber,
          groupIDs,
          tripStartLocation: this.state.tripStartLocation ? this.state.tripStartLocation : '',
          tripEndLocation: this.state.tripEndLocation ? this.state.tripEndLocation : '',
          startDate: this.state.startDate ? this.state.startDate : '',
          endDate: this.state.endDate ? this.state.endDate : '',
          estimatedDeparture: this.state.estimatedDeparture,
          esignEnabled: this.state.esignEnabled ? this.state.esignEnabled : false,
          esignEnabledBOL: this.state.esignEnabledBOL ? this.state.esignEnabledBOL : false
        }, { merge: true }),
      ...promises,
    ])
      .then(() => resolve('Document created/editted'))
      .catch((err) => reject(err));
  });

  checkForErrors = () => {
    const returnObjs = {
      error: function (message) {
        return {
          error: true,
          message,
        };
      },
      success: function (message, data) {
        return {
          data,
          error: false,
          message,
        };
      },
    };
    const isCanceled = this.state.status === 'Canceled';

    const errorHandling = {
      keyBools: function (keysArr, checkObj) {
        const missing = [];
        for (let i = 0; i < keysArr.length; i++) {
          if (!checkObj[keysArr[i].label]) missing.push(keysArr[i].name);
        }

        if (missing.length)
          return returnObjs.error(`Missing ${missing.join(', ')}`);

        return returnObjs.success(
          'All object keys have a boolean value of true'
        );
      },
      arrayLength: function (arr) {
        if (!arr) return returnObjs.error('Parameter sent is not truthy value');
        if (!Array.isArray(arr)) return returnObjs.error('Parameter sent is not an array');
        if (!(isCanceled || arr.length)) return returnObjs.error('Array does not have content');

        return returnObjs.success('Parameter sent is an array');
      },
      isTripType: function (tripType) {
        if (!tripType) return returnObjs.error('No trip type Selected');
      },
      properRates: function (tripRate, orderRates) {
        if (!(isCanceled || tripRate)) return returnObjs.error('Missing the trip rate');
        if (!(isCanceled || orderRates.length)) return returnObjs.error('No selected orders');

        const orderRateTotal = parseFloat(
          orderRates.length ?
            orderRates
              .reduce((accumulator, value) => accumulator + value)
              .toFixed(2) :
            0
        );

        if (orderRateTotal !== parseFloat(tripRate))
          return returnObjs.error('Sum of order rates not equal to trip rate');

        return returnObjs.success('Order rates add up to trip rate', {
          tripRate,
          orderRateTotal,
        });
      },
      isDate: function (date, name) {
        if (!date) return returnObjs.error(`${name} not selected`);
        if (!(date instanceof Date)) return returnObjs.error(`${name} is invalid, unknown reason`);
        return returnObjs.success('Is a date');
      },
      locationCheck: function (location) {
        const errors = [];

        const keysExist = this.keyBools(
          [
            { label: 'address', name: 'address' },
            { label: 'city', name: 'city' },
            { label: 'state', name: 'state' },
            { label: 'zip', name: 'zip code' },
          ],
          location
        );

        if (keysExist.error) {
          errors.push(keysExist.message);
        }

        if (location.zip && location.zip.length !== 5)
          errors.push('Zip code must be 5 characters long');

        if (errors.length) return returnObjs.error(errors.join(', '));

        return returnObjs.success('All location values are correct');
      },
    };

    const getErrors = [
      errorHandling.properRates(
        this.state.tripRate,
        this.state.selectedOrders.map((order, i, self) =>
          order.rate
            ? order.rate
            : parseFloat(this.state.tripRate) / self.length
        )
      ),
      errorHandling.keyBools(
        [
          { label: 'vendorSelected', name: 'vendor' },
          { label: 'tripRate', name: 'trip rate' },
          { label: 'tripType', name: 'trip type' }
        ],
        this.state
      ),
      errorHandling.arrayLength(this.state.selectedOrders),
      errorHandling.isDate(this.state.estimatedDeparture, 'Estimated Departure')
    ];

    if (this.state.pickUpLocation) {
      getErrors.push(
        errorHandling.locationCheck(this.state.pickUpLocation)
      );
    }
    if (this.state.dropOffLocation) {
      getErrors.push(
        errorHandling.locationCheck(this.state.dropOffLocation)
      );
    }

    if (!this.state.pickUpLocation && !this.state.dropOffLocation) {
      // getErrors.push(returnObjs.error("No location information given"));
    }
    if (!this.state.tripType) {
      getErrors.push(errorHandling.isTripType(this.state.tripType));
    }

    const errors = getErrors.filter((err) => err.error);

    if (errors.length)
      return {
        hasErrors: true,
        errors,
      };

    return { hasErrors: false };
  };

  newTripNumber = async () => {
    const tripNumberRef = db.collection('haney-trip-counter').doc('count');

    const tripNumberSnap = await tripNumberRef.get();
    const { count } = tripNumberSnap.data();
    await tripNumberRef.set(
      {
        count: count + 1,
      },
      { merge: true }
    );

    return count;
  };

  addTrip = () => {
    const { selectedOrders } = this.state;
    const docID = uuidv1();

    db.collection('haneyTrips').doc(docID).set({createdAt: new Date() }, { merge: true });

    this.save(docID)
      .then((res) => {
        // console.log(res);
        this.setState(
          {
            ...INITIAL_STATE,
            dataLoaded: true,
            ordersData: [
              ...this.state.ordersData,
              ...selectedOrders,
            ].sort((a, b) =>
              parseInt(a.freightBillNumber) < parseInt(b.freightBillNumber)
                ? 1
                : -1
            ),
            snackInfo: {
              open: true,
              severity: 'success',
              message: 'Trip created successfully',
            },
          },
          () => (window.location.href = `/trips/${docID}`)
        );
      })
      .catch((err) => console.log(err));
  };

  updateTrip = () => {
    const docID = this.props.tripID;

    this.save(docID)
      .then(_ => Promise.all(this.state.selectedOrders.map(order => this.setExpenses(order))))
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => console.log('point11', err));
  };

  saveTrip = () => {
    this.setState({
      isClicked: true,
    });
    const errorsObj = this.checkForErrors();
    if (errorsObj.hasErrors) {
      return this.setState({
        isClicked: false,
        snackInfo: {
          open: true,
          severity: 'error',
          message: errorsObj.errors[0].message,
        },
      });
    }
    if (!errorsObj.hasErrors) {
      this.setState({
        snackInfo: {
          open: true,
          severity: 'success',
          message: 'Trip Saved',
        },
      });
    }
    this.props.trip && this.props.trip.orders
      ? this.updateTrip()
      : this.addTrip();
    setTimeout(
      this.setState({
        isClicked: false,
      }),
      5000
    );
  };

  dispatchBOLs = async () => {
    const {
      savedOrdersData,
      selectedOrders,
      driverSelected,
      pickUpLocation,
      dropOffLocation,
      pickUpBy,
      dropOffBy,
      esignEnabledBOL,
      tripNumber: count,
      startDate,
      endDate,
      tripStartLocation,
      tripEndLocation,
    } = this.state;

    const tripNumber = count ? count : await this.newTripNumber();
    if (!count) this.setState({ tripNumber });

    const allSelectedData = await this.getSelectedData();
    // console.log('secondTime');

    const groups = {};
    allSelectedData.map((d) => {
      if (d.groups && d.groups.length) {
        d.groups.map((group) => {
          if (!groups[group]) groups[group] = true;
        });
      }
    });

    const orderChanges = {};

    const vendor = this.state.vendorsData.find(
      (vendor) => vendor.name === this.state.vendorSelected
    );
    const driver = this.state.driversData.find(
      (driver) => driver.name === this.state.driverSelected
    );

    if (vendor) {
      const vendorName = vendor.name.split(' - ')[0];
      orderChanges.vendorPickUp = {
        ...vendor,
        name: vendorName,
      };
      orderChanges.vendorPickUpName = vendorName;
      orderChanges.vendorPickUpID = vendor.id;
      orderChanges.vendorPickUpEmail = vendor.email ? vendor.email : '';
    }

    if (driver) {
      const [firstName, lastName] = driver.name.split(' ');
      driver.firstName = firstName;
      driver.lastName = lastName;
      orderChanges.pickUpDriver = driver;
    }

    // console.log(allSelectedData, 'Morty');

    const allOrdersData = allSelectedData.map((order, i) => ({
      ...order,
      ...orderChanges,
      pickUpBy: selectedOrders[i].pickUpBy,
      dropOffBy: selectedOrders[i].dropOffBy
    }));

    this.setState((prevState) => {
      prevState.documentsLoading += allOrdersData.filter((order, i) => selectedOrders[i].generateBOL).length + 1;
      return prevState;
    });



    const [rRateCon, ...rBOLs] = await Promise.all([
      this.generateRateCon(allOrdersData),
      ...allOrdersData.map((order, i) =>
        selectedOrders[i].generateBOL
          ? this.generateBOL(order, i, esignEnabledBOL)
          : {
            hashes: {
              bolHash:  allOrdersData[i].bolHash ? allOrdersData[i].bolHash : "",
              bolHashURL: allOrdersData[i].bolHashURL ? `https://api.eversign.com/api/download_current_document_status?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${allOrdersData[i].bolHash}&audit_trail=1` : "",
            },
            fileURL: allOrdersData[i].fileURL,
            urls: { signingURLs: allOrdersData[i].signingURLs },
            regenerated: false,
            freightBillNumber: allOrdersData[i].freightBillNumber,
            stop: Number(i) + 1,
          }
      ),
    ]);

    allOrdersData.map(order => {
      delete order.pickUpBy;
      delete order.dropOffBy;
      return order;
    });

    // console.log(rRateCon, rBOLs);

    const setOrderPromises = [];
    const expensesPromises = [];

    const newTrip = {
      id: this.props.tripID,
      tripNumber: this.props.trip.tripNumber,
      vendorId: vendor.id,
      pickUpCity: pickUpLocation
        ? pickUpLocation.city
          ? pickUpLocation.city
          : ''
        : '',
      dropOffCity: dropOffLocation
        ? dropOffLocation.city
          ? dropOffLocation.city
          : ''
        : '',
      pickUpDate: pickUpBy ? pickUpBy : '',
      dropOffDate: dropOffBy ? dropOffBy : '',
      driver: driverSelected,
      driverFull: driver ? driver : '',
      rateConURL: rRateCon.fileURL,
      rateConHash: rRateCon.hash,
    };
    // console.log('MeeSeeks', allOrdersData);
    const ordersWDocuments = allOrdersData.map((order, i) => {
      const changes = {};
      if (['Booked', 'booked'].includes(order.status)) {
        changes.status = 'Dispatched';
      }

      if (order.trips) {
        const tripIndex = order.trips.findIndex(
          (trip) => trip.id === this.props.tripID
        );

        if (tripIndex > -1) {
          order.trips.splice(tripIndex, 1, newTrip);
        } else {
          order.trips.push(newTrip);
        }
      } else {
        order.trips = [newTrip];
      }

      changes.docs = {
        ...order.docs,
        rateCon: rRateCon,
      };

      const { urls, hashes, shipperBOLIsSigned, driverBOLIsSigned, consigneeBOLIsSigned } = rBOLs[i]
        ? rBOLs[i]
        : {
          urls: {},
          hashes: {}
        };

      // console.log("stop: " + i);
      // console.log(urls)
      // console.log(selectedOrders[i])

      const newOrder = {
        ...order,
        ...urls,
        ...hashes,
        // shipperBOLIsSigned,
        // driverBOLIsSigned,
        // consigneeBOLIsSigned,
        ...changes,
        stop: String(i + 1),
      };

      delete newOrder.actions;

      console.log("newOrder: " + JSON.stringify(newOrder));

      selectedOrders[i].rate = selectedOrders[i].rate
        ? selectedOrders[i].rate
        : parseFloat(this.state.tripRate) / selectedOrders.length;

      setOrderPromises.push(
        db
          .collection('haney-orders')
          .doc(order.id)
          .set(newOrder, { merge: true })
      );
      setOrderPromises.push(
        db
          .collection('haney-orders')
          .doc(order.id)
          .collection('statusLogs')
          .doc()
          .set(
            {
              status: 'Dispatched',
              trip: this.state.tripNumber,
              type: 'status',
              updatedAt: new Date(),
              updatedBy: {
                uid: this.props.authUser.uid,
                name: this.props.user.displayName
                  ? this.props.user.displayName
                  : this.props.user.firstName + ' ' + this.props.user.lastName,
              },
            },
            { merge: true }
          )
      );

      expensesPromises.push(this.setExpenses(selectedOrders[i]));

      return newOrder;
    });

    const ordersWNewBOL = selectedOrders
      .filter((order) => order.generateBOL)
      .map((order) => order.freightBillNumber)
      .join(', ');

    this.setState(
      {
        rateConURL: rRateCon.fileURL,
        rateConHash: rRateCon.hash,
        selectedOrders: selectedOrders.map((order) => ({
          ...order,
          generateBOL: false,
        })),
      },
      () => {
        Promise.all([
          ...setOrderPromises,
          ...expensesPromises,
          this.save(this.props.tripID),
        ])
          .then(async (responses) => {
            console.log("Responses:" + responses);

            const emailPromises = [];

            ordersWDocuments.map((order, i) => {
              if (rBOLs[i].regenerated) {
                emailPromises.push(
                  this.emailBOL(
                    "https://cargo-rx.web.app/pages/login-page",
                    order,
                    rBOLs[i].urls.signingURLs[0],
                    order.origin.email,
                    "Shipper",
                    "",
                    "origin"
                  )
                );
                emailPromises.push(
                  this.emailBOL(
                    "https://cargo-rx.web.app/pages/login-page",
                    order,
                    rBOLs[i].urls.signingURLs[2],
                    order.destination.email,
                    "Consignee",
                    "",
                    "destination"
                  )
                );
                // emailPromises.push(this.emailBOL("https://haney-freightways-vendor.web.app/pages/login-page", order, rBOLs[i].urls.signingURLs[1], order.vendorPickUp.email, "Pick Up Vendor", newTrip.rateConURL, rBOLs[i].hashes.bolHash));
                // emailPromises.push(this.emailBOL("", order, rBOLs[i].urls.signingURLs[1], order.pickUpDriver.email, "Pick Up Driver", newTrip.rateConURL, rBOLs[i].hashes.bolHash));
                if (order.thirdParty && order.thirdParty.email)
                  emailPromises.push(
                    this.emailBOL(
                      "https://cargo-rx.web.app/pages/login-page",
                      order,
                      false,
                      order.thirdParty.email,
                      "Third Party",
                      "",
                      "thirdParty"
                    )
                  );
              }
            });
            // console.log(ordersWDocuments, 'PickleRick');
            driver && emailPromises.push(this.textDriver(newTrip));
            console.log(newTrip)

            console.log(ordersWDocuments, '"texted driver"');

            // emailPromises.push(this.emailBOL("https://haney-freightways-vendor.web.app/pages/login-page", newTrip, rBOLs, ordersWDocuments[0].vendorPickUp.email, "Pick Up Vendor", newTrip.rateConURL));
            emailPromises.push(
              this.emailRateCon(
                'https://cargo-rx-vendor.web.app/pages/login-page',
                ordersWDocuments,
                rBOLs,
                vendor.email,
                'Pick Up Vendor',
                rRateCon.fileURL
              )
            );

            driver &&
              emailPromises.push(
                this.emailRateCon(
                  '',
                  ordersWDocuments,
                  rBOLs,
                  driver.email,
                  'Pick Up Driver',
                  rRateCon.fileURL
                )
              );

            const emailReturns = await Promise.all(emailPromises);
            console.log("emailReturns " + emailReturns);

            // db
            //   .collection('haney-vendors')
            //   .doc(newTrip.vendorId)


            db
              .collection('haneyTrips')
              .doc(newTrip.id)
              .set({ status: 'Dispatched', dispatchedAt: new Date() }, { merge: true });

            this.setState({
              documentsLoading: 0,
              documentsLoaded: 0,
              snackInfo: {
                open: true,
                severity: "success",
                message: `Rate Con generated for trip.${ordersWNewBOL}`
                  ? ` BOLs were successfully generated for ${ordersWNewBOL}`
                  : ""
              },
            });
          })
          .then(() => console.log("finished"))
          .then(() => console.log("success"))
          .catch((err) => {
            console.log("Error: " + err);
            if (!this.state.snackInfo.open) {
              this.setState({
                documentsLoading: 0,
                documentsLoaded: 0,
                snackInfo: {
                  open: true,
                  severity: 'error',
                  message: `BOLs were generated but there was a problem setting the order data. Please contact the system administrator with this issue`,
                },
              });
            }
          });
      }
    );
  };

  emailRateCon = async (
    loginLink,
    orders,
    urlsAndHashes,
    email,
    party,
    rateCon
  ) => {
    const {
      pickUpLocation,
      dropOffLocation,
      selectedOrders,
      isPickUp,
      isDropOff,
    } = this.state;

    const emailOrders = [...new Array(orders.length)].map(_ => ({
      origin: {
        businessName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
      },
      destination: {
        businessName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
      }
    }));
    // selectedOrders[i].pickupLocation  refers to order level alternate pickup address
    // selectedOrders[i].dropOffLocation refers to order level alternate dropOff address
    // pickUpLocation refers to trip level pickup address
    // dropOffLocation

    for (let i = 0; i < emailOrders.length; i++) {
      // console.log('Magnet');
      // console.log([emailOrders[i].origin, selectedOrders[i], orders[i].origin]);

      emailOrders[i].origin.businessName = selectedOrders[i].isPickUp
        ? selectedOrders[i].pickUpLocation.entityName
        : isPickUp
          ? pickUpLocation
            ? pickUpLocation.entityName
            : ' '
          : orders[i].origin.businessName;
      emailOrders[i].origin.address = selectedOrders[i].isPickUp
        ? selectedOrders[i].pickUpLocation.address
        : isPickUp
          ? pickUpLocation
            ? pickUpLocation.address
            : ' '
          : orders[i].origin.address;
      emailOrders[i].origin.state = selectedOrders[i].isPickUp
        ? selectedOrders[i].pickUpLocation.state
        : isPickUp
          ? pickUpLocation
            ? pickUpLocation.state
            : ' '
          : orders[i].origin.state;
      emailOrders[i].origin.city = selectedOrders[i].isPickUp
        ? selectedOrders[i].pickUpLocation.city
        : isPickUp
          ? pickUpLocation
            ? pickUpLocation.city
            : ' '
          : orders[i].origin.city;
      emailOrders[i].origin.zip = selectedOrders[i].isPickUp
        ? selectedOrders[i].pickUpLocation.zip
        : isPickUp
          ? pickUpLocation
            ? pickUpLocation.zip
            : ' '
          : orders[i].origin.zip;

      emailOrders[i].destination.businessName = selectedOrders[i].isDropOff
        ? selectedOrders[i].dropOffLocation.entityName
        : isDropOff
          ? dropOffLocation
            ? dropOffLocation.entityName
            : ' '
          : orders[i].destination.businessName;
      emailOrders[i].destination.address = selectedOrders[i].isDropOff
        ? selectedOrders[i].dropOffLocation.address
        : isDropOff
          ? dropOffLocation
            ? dropOffLocation.address
            : ' '
          : orders[i].destination.address;
      emailOrders[i].destination.state = selectedOrders[i].isDropOff
        ? selectedOrders[i].dropOffLocation.state
        : isDropOff
          ? dropOffLocation
            ? dropOffLocation.state
            : ' '
          : orders[i].destination.state;
      emailOrders[i].destination.city = selectedOrders[i].isDropOff
        ? selectedOrders[i].dropOffLocation.city
        : isDropOff
          ? dropOffLocation
            ? dropOffLocation.city
            : ' '
          : orders[i].destination.city;
      emailOrders[i].destination.zip = selectedOrders[i].isDropOff
        ? selectedOrders[i].dropOffLocation.zip
        : isDropOff
          ? dropOffLocation
            ? dropOffLocation.zip
            : ' '
          : orders[i].destination.zip;

      // console.log('Magnet');
    }
    // console.log("CLOSING", emailOrders[0].origin)
    // console.log("After-orders", orders)
    // console.log("2ndAfter-emailOrders", emailOrders)

    const [firstOrder, lastOrder] = [
      emailOrders[0],
      emailOrders[emailOrders.length - 1],
    ];

    // console.log('FireWorks', this.state);
    // console.log('HAPPY', emailOrders);
    // console.log(pickUpLocation, dropOffLocation);

    const data = {
      tripNumber: this.props.trip.tripNumber,
      ground: true,
      shipper: party === 'Shipper',
      consignee: party === 'Consignee',
      thirdParty: party === 'Third Party',
      pickUpVendor: party === 'Pick Up Vendor',
      pickUpDriver: party === 'Pick Up Driver',
      // pickup: emailOrders[0].isPickup ? false : pickUpLocation ? true : false,
      // delivery: emailOrders[emailOrders.length - 1].isDropOff ? false : dropOffLocation ? true : false,
      pickup: false,
      delivery: false,
      shipper_name: emailOrders[0].origin.businessName,

      shipper_address:
        firstOrder.origin.address +
        ' ' +
        firstOrder.origin.city +
        ' ' +
        firstOrder.origin.zip,

      shipper_contact:
        firstOrder.origin.firstName + ' ' + firstOrder.origin.lastName,
      shipper_phone: firstOrder.origin.phone,
      // shipper_pickup: moment(firstOrder.origin.date.toDate()).format('MM/DD/YYYY') + " " + (firstOrder.origin.startTimeWindow ? firstOrder.origin.startTimeWindow : " ") + " - " + (firstOrder.origin.endTimeWindow ? firstOrder.origin.endTimeWindow : " "),
      shipper_service: firstOrder.origin.customExtraService
        ? firstOrder.origin.customExtraService
        : ' ',
      shipper_rn: firstOrder.origin.referenceID
        ? firstOrder.origin.referenceID
        : ' ',
      consignee_rn: lastOrder.destination.referenceID
        ? lastOrder.destination.referenceID
        : ' ',
      // Consignee Data
      consignee_name: lastOrder.destination.businessName,
      consignee_address:
        lastOrder.destination.address +
        ' ' +
        lastOrder.destination.city +
        ' ' +
        lastOrder.destination.zip,
      consignee_contact:
        lastOrder.destination.firstName + ' ' + lastOrder.destination.lastName,
      consignee_phone: lastOrder.destination.phone,
      // consignee_dropoff: lastOrder.serviceETA ? moment(lastOrder.serviceETA.toDate()).format('MM/DD/YYYY HHmm') : " ",
      consignee_service: lastOrder.destination.customExtraService
        ? lastOrder.destination.customExtraService
        : ' ',
      // 3rd Party Data
      alt_pickup_name: emailOrders[0].origin.businessName,

      //---
      alt_pickup_address:
        emailOrders[0].origin.address +
        ' ' +
        emailOrders[0].origin.city +
        ' ' +
        emailOrders[0].origin.zip,

      alt_pickup_contact: pickUpLocation ? pickUpLocation.contactName : false,
      alt_pickup_phone: pickUpLocation ? pickUpLocation.contactPhone : false,
      // alt_pickup_email: terminalInfo.email ? terminalInfo.email : ' ',
      alt_delivery_name: lastOrder.destination.businessName,

      alt_delivery_address:
        emailOrders[emailOrders.length - 1].destination.address +
        ' ' +
        emailOrders[emailOrders.length - 1].destination.city +
        ' ' +
        emailOrders[emailOrders.length - 1].destination.state +
        ' ' +
        emailOrders[emailOrders.length - 1].destination.zip,

      alt_delivery_contact: dropOffLocation
        ? dropOffLocation.contactName
        : false,
      alt_delivery_phone: dropOffLocation
        ? dropOffLocation.contactPhone
        : false,

      party: party,
      orders: emailOrders.length > 1 ? emailOrders : null,
      urls: urlsAndHashes[0].urls.signingURLs,
      hashes: urlsAndHashes[0].hashes.bolHashURL,
      order_stop: 1,
      order_number: emailOrders[0].freightBillNumber,
      order_id: emailOrders[0].id,
      tracking_link: `https://cargo-rx.web.app/pages/orders/${emailOrders[0].id}`,
      order_origin_businessName: emailOrders[0].origin.businessName,

      order_origin_address:
        emailOrders[0].origin.address +
        ' ' +
        emailOrders[0].origin.state +
        ' ' +
        emailOrders[0].origin.zip,

      order_origin_phone: emailOrders[0].origin.phone,

      order_origin_contact: emailOrders[0].origin.contact,

      order_destination_businessName: emailOrders[0].destination.businessName,

      order_destination_address:
        emailOrders[0].destination.address +
        ' ' +
        emailOrders[0].destination.city +
        ' ' +
        emailOrders[0].destination.state +
        ' ' +
        emailOrders[0].destination.zip,
      order_destination_phone: emailOrders[0].destination.phone,
      order_destination_contact: emailOrders[0].destination.contact,
      driverLink: `https://cargo-rx-driver.web.app/pages/trip/${this.props.tripID}`,
      // bols: bol,
      // bol: bol[0].hashes,
      rateLink: rateCon,
      loginLink: loginLink,
      // bolLink: (docs && docs.alternateBOL) ? docs.alternateBOL.fileURL : null,
    };
    // console.log('ORANGE', data);

    const subject = `CargoRx`;
    // const emails = [email, "justin@pondata.com"];
    const emails = [
      email,
      party == 'Pick Up Vendor' || party == 'Pick Up Driver'
        ? 'vendoralerts@haneyfreightways.com'
        : 'customeralerts@haneyfreightways.com',
      'justin@pondata.com',
    ];
    const attachment = true;
    //  const emails = ["justin@pondata.com"];        const attachment = true;

    //   console.log("Sending BOL info to:", email);

    const emailReturn = await sendDynamicEmail({
      emails,
      subject,
      template: 'd-ff3dad51ae294eb88f3e498d2e4163e9',
      data,
    });
    // console.log(this.state, 'BROKEN');
    return emailReturn;
  };

  emailBOL = async (loginLink, order, bol, email, party, rateCon, partyObj) => {
    const {
      origin,
      destination,
      thirdParty,
      items,
      deliveryType,
      subDeliveryType,
      freightBillNumber,
      serviceETA,
      docs,
      pickUpLocation,
      dropOffLocation,
    } = order;

    const { selectedOrders } = this.state;
    console.log('LOOK1 ' + party);
    // console.log(pickUpLocation, dropOffLocation);

    let weight = 0;

    const dataItems = items.map((item) => {
      const wpp = parseFloat(item.weight ? item.weight : 0);
      const qty = parseFloat(item.quantity ? item.quantity : 0);
      weight += wpp * qty;
      return {
        item_number: item.number,
        item_packaging: item.packaging,
        item_quantity: item.quantity,
        item_weight: item.weight,
        // item_total: item.total,
        item_length: item.length,
        item_width: item.width,
        item_height: item.height,
        item_value: item.declaredValue,
        item_description: item.description,
      };
    });

    let party_address

    if (thirdParty) {
      if (thirdParty.city) {
        party_address = thirdParty.address
        ? (thirdParty.address ? thirdParty.address : ' ') +
        ' ' +
        (thirdParty.city ? thirdParty.city : ' ') +
        ' ' +
        (thirdParty.zip ? thirdParty.zip : ' ')
        : undefined;
      }
    }

    const data = {
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      accufrate: deliveryType == 'LTL' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: party == 'Shipper' ? true : false,
      consignee: party == 'Consignee' ? true : false,
      thirdParty: party == 'Third Party' ? true : false,
      pickUpVendor: party == 'Pick Up Vendor' ? true : false,
      pickUpDriver: party == 'Pick Up Driver' ? true : false,
      party: party,
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HHmm')
        : ' ',
      consignee_service: destination.customExtraService,
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      link: bol,
      driverLink: `https://cargo-rx-driver.web.app/pages/trip/${order.id}`,
      // bols: bol,
      // bol: bol[0].hashes,
      rateLink: rateCon,
      loginLink: loginLink,
      bolLink: docs && docs.alternateBOL ? docs.alternateBOL.fileURL : null,
      // Item Data
      weight: weight,
      items: dataItems.length > 1 ? dataItems : null,
      ...dataItems[0],
    };

    const subject = `CargoRx #${freightBillNumber} Shipping Documents${bol ? ' - Your Signature May be Required!' : ''
      }`;
    // console.log(order["origin"])
    // console.log(partyObj)
    // console.log(order[partyObj])

    const attachment = true;
    const emails = [
      email,
      party == 'Pick Up Vendor' || party == 'Pick Up Driver'
        ? 'vendoralerts@haneyfreightways.com'
        : 'customeralerts@haneyfreightways.com',
      'justin@pondata.com',
    ];
    // const emails = ["justin@pondata.com"];        const attachment = true;

    // console.log('Sending BOL info to:', email);

    const emailReturn = await sendDynamicEmail({
      emails,
      subject,
      template:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air'
          ? 'd-66ebd124ba204f58a33f2d965eeaedae'
          : party == 'Pick Up Vendor'
            ? 'd-ff3dad51ae294eb88f3e498d2e4163e9'
            : party == 'Pick Up Driver'
              ? 'd-ff3dad51ae294eb88f3e498d2e4163e9'
              : 'd-be3ca4a997054d0aa2746d3a3f9874b3',
      data,
    });

    return emailReturn;
  };

  textDriver = (newTrip) => new Promise(async (resolve, reject) => {
    // console.log('texting driver', newTrip.driverFull.id);
    const driverSnap = await db.collection('TEST-users').doc(newTrip.driverFull.id).get();
    const driver = driverSnap.data();
    // console.log(driver);
    // let body = `Thank you for partnering with Haney Freightways on trip number ${newTrip.tripNumber} from ${newTrip.pickUpCity} `
    let body = `Thank you for partnering with CargoRx on trip number ${newTrip.tripNumber}`;
    body += `\nPlease click the link for our CargoLink technology which gives you access to this trip's e-manifest, electronic documents, document and freight picture uploads, and status update triggers.`;
    body += `\nPlease "Allow Location Services" once you've clicked on the CargoLink extension below.`;
    const from = '+18885986250';
    const to = '+1' + (driver.cell ? driver.cell : driver.cellPhone);

    sendSMS({
      body,
      from,
      to
    })
      .then(res => {
        console.log(res);
        return sendSMS({
          body: `\nLiveLync: https://cargo-rx-driver.web.app/pages/trip/${newTrip.id}`,
          from,
          to
        })
      })
      .then(resolve)
      .catch(reject);
  });

  setExpenses = async (order) => {
    const vendor = this.state.vendorsData.find(
      (v) => v.name === this.state.vendorSelected
    );

    const registerRef = db
      .collection('haney-orders')
      .doc(order.id)
      .collection('register');

    const initialExpensesSnapshot = await registerRef
      .where('tripID', '==', this.props.tripID)
      .get();
    const initialExpenses = initialExpensesSnapshot.docs.map((expense) => ({
      ...expense.data(),
      id: expense.id,
    }));

    const newExpenses = {
      carrierExpense: {
        dollarAmount: parseFloat(order.rate),
        category: 'expense',
        type: 'carrier expense',
        tripID: this.props.tripID,
        tripNumber: this.state.tripNumber,
        business: {
          businessName: vendor.name,
          id: vendor.id,
        },
        description: `Rate given for trip #${this.props.tripID}`,
      },
    };

    const promises = [];

    for (let key in newExpenses) {
      const initialExpense = initialExpenses.find(
        (e) => e.type === newExpenses[key].type
      );

      console.log("Init " + JSON.stringify(initialExpense))
      console.log("New " + JSON.stringify(newExpenses))
      // console.log("Init " + initialExpense.dollarAmount)
      // console.log("New " + newExpenses.dollarAmount)

      if (
        initialExpense &&
        ((initialExpense.business.businessName !== newExpenses[key].business.businessName) || (initialExpense.dollarAmount !== newExpenses[key].dollarAmount))
      ) {
        console.log("update register")
        promises.push(
          registerRef.doc(initialExpense.id).set(
            {
              dollarAmount: newExpenses[key].dollarAmount,
              business: newExpenses[key].business,
            },
            { merge: true }
          )
        );
      } else if (!initialExpense) {
        promises.push(registerRef.add(newExpenses[key]));
      }
    }

    const setReturns = await Promise.all(promises);

    return true;
  };

  assignTripOrderBusiness = (doc, arr, query, objName, index) => {
    const { selectedOrders } = this.state;
    selectedOrders[index][`${objName}Location`] = {
      address: doc.physicalAddress ? doc.physicalAddress : '',
      city: doc.physicalCity ? doc.physicalCity : '',
      state: doc.physicalState ? doc.physicalState : '',
      zip: doc.physicalZip ? doc.physicalZip : '',
      entityName: doc.name,
      entityID: doc.id,
    }
    this.setState((prevState) => ({
      selectedOrders: this.state.selectedOrders,
    }));
  };

  assignBusiness = (doc, arr, query, objName) => {
    this.setState((prevState) => ({
      [query]: '',
      [`${objName}Location`]: {
        address: doc.physicalAddress ? doc.physicalAddress : '',
        city: doc.physicalCity ? doc.physicalCity : '',
        state: doc.physicalState ? doc.physicalState : '',
        zip: doc.physicalZip ? doc.physicalZip : '',
        entityName: doc.name,
        entityID: doc.id,
      },
    }));
  };

  assignBusinessTripOrder = (doc, arr, query, objName, index) => {
    this.setState((prevState) => {
      prevState.selectedOrders[index][`${objName}Location`] = {
        address: doc.physicalAddress ? doc.physicalAddress : '',
        city: doc.physicalCity ? doc.physicalCity : '',
        state: doc.physicalState ? doc.physicalState : '',
        zip: doc.physicalZip ? doc.physicalZip : '',
        entityName: doc.name,
        entityID: doc.id,
      };
      return { ...prevState };
    });
  };

  toggleBOL = (e, index) => {
    e.stopPropagation();
    // console.log('Toggle BOL');
    this.setState((prevState) =>
      prevState.selectedOrders[index].generateBOL
        ? (prevState.selectedOrders[index].generateBOL = false)
        : (prevState.selectedOrders[index].generateBOL = true)
    );
  };

  handleItemSelectChange = (e, i) => {
    this.setState({ alternateAddress: e.target.value });
  };

  loadAltInfo = () => {
    const { selectedOrders } = this.state;

    this.props.trip.orders.map((order, i) => {
      selectedOrders[i].pickUpBy = order.pickUpBy
        ? order.pickUpBy.toDate()
        : null;
      selectedOrders[i].pickUpLocation = order.pickUpLocation;
      selectedOrders[i].isPickUp = order.isPickUp;
      selectedOrders[i].isDropOff = order.isDropOff;
      selectedOrders[i].dropOffLocation = order.dropOffLocation;
      selectedOrders[i].dropOffBy = order.dropOffBy
        ? order.dropOffBy.toDate()
        : null;
    });

    const rates = selectedOrders.map((order, i, self) => order.rate ? order.rate : parseFloat(this.state.tripRate ? this.state.tripRate : 0) / self.length);
    const ratesAdded = rates.reduce(
      (accumulator, currentValue) =>
        parseFloat(accumulator) + parseFloat(currentValue)
    );

    this.setState({
      selectedOrders,
      tripRate: ratesAdded,
      altInfoLoaded: true
    });
  };

  getAllOrders = () => {
    this.setState({ getAll: true });
    this.getOrders(false);
  }

  handleSwitchChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  loadTrips = async () => {
    const registerRef = db
      .collection('haneyTrips');

    const tripsSnapshot = await registerRef.where('tripNumber', '>=', 9801).where('tripNumber', '<=', 9900).get();
    const trips = tripsSnapshot.docs.map((trip) => ({
      ...trip.data(),
      id: trip.id,
    }));

    this.setState({trips: trips, tripsLoaded: true})
  }

  refactor = () => {
     this.state.trips.map(async (trip, i) => (
      
      await setTimeout(async () => {
        // do stuff function with item
        await db.collection('haney-orders').doc(trip.orders[0] ? trip.orders[0].orderID : "a")
      .get().then((snapshot) => {
          var docData = snapshot.data()
          if (docData) {
              var docObj = {
                  ...docData,
                  id: snapshot.id,
              }
              return (docObj)
          } else {
              return (null)
          }
      }, (error) => {
          console.log('error fetching data: ', error)
      }).then(async docObj => {
        await db.collection('haneyTrips')
          .doc(trip.id)
          .set({
            createdAt: docObj.destination.date.toDate(),
            dispatchedAt: docObj.destination.date.toDate(),
            estimatedDeparture: trip.estimatedDeparture ? trip.estimatedDeparture.toDate() : docObj.destination.date.toDate()
          }, { merge: true }).then(() => {
            console.log(trip.id);
          })
      })

      }, 1000*10 )
      
      //console.log(trip.orders[0] ? trip.orders[0].orderID : null)
      )
    )
}

  render() {
    const { classes } = this.props;
    console.log("state", this.state)

    const locationsData = [
      {
        isOpen: this.state.isPickUp,
        data: this.state.pickUpLocation,
        labels: ['pickUp', 'Pick Up'],
      },
      {
        isOpen: this.state.isDropOff,
        data: this.state.dropOffLocation,
        labels: ['dropOff', 'Drop Off'],
      },
    ];

    const tripTypes = [
      '', 
      'Owned Asset Outbound',
      'Owned Asset Inbound',
      'Owned Asset Relay',
      'Owned Asset Skip',
      'Brokered Outbound',
      'Brokered Inbound',
      'Brokered Relay',
      'Brokered Skip',
      'In-Town Pickup',
      'In-Town Delivery',
      'In-Town Trailer Drop',
      'In-Town Trailer Recovery',
      'Storage Trailer',
      'Dead Head'];
    

    if (this.props.trip) {
      if (
        this.props.trip.orders &&
        this.state.selectedOrders.length > 0 &&
        !this.state.altInfoLoaded
      ) {
        this.loadAltInfo();
      }
    }

    // if (!this.state.tripsLoaded) {
    //   this.loadTrips()
    // }

    const selectedOrder = this.state.selectedOrder ? this.state.selectedOrder : { freightBillNumber: 'No order found' };

    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? String(row[id])
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : true;
    }

    let totalTripRevenue;
    let totalTripCM;
    let totalTripCMPercent;

    if (this.state.selectedOrders.length > 0) {

      totalTripRevenue = this.state.selectedOrders.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.totalRevenue.replace(/[$,]+/g, ""))
      }, 0);

      totalTripCM = totalTripRevenue - parseFloat(this.state.tripRate);
      totalTripCMPercent = Math.round((totalTripCM / totalTripRevenue) * 10000) / 100;
    }
    
  //  console.log('trips: ' + this.state.trips);

    return this.state.dataLoaded ? (
      <GridContainer justify="center">
         {/* <Button
                        color='primary'
                        onClick={() =>
                          this.refactor()
                        }
                    >
                        refactor
                    </Button> */}
        <GridItem xs={11}>
          <GridContainer>
            {this.props.trip && (
              <React.Fragment>
                <GridItem xs={12}>
                  <GridContainer justify="space-between">
                    <GridItem xs={12}>
                      <h1>Trip #{this.props.trip.tripNumber}</h1>
                    </GridItem>
                    <GridItem xs={12}>
                      <b>Enable Rate Con E-sign:</b>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.esignEnabled}
                            onChange={this.handleSwitchChange("esignEnabled")}
                            value="esignEnabled"
                            classes={{
                              switchBase: classes.switchBase,
                              checked: classes.switchChecked,
                              icon: classes.switchIcon,
                              iconChecked: classes.switchIconChecked,
                              bar: classes.switchBar,
                            }}
                          />
                        }
                        classes={{
                          label: classes.label,
                        }}
                        style={{ marginLeft: "10px" }}
                      />
                      <b>Enable BOL E-sign:</b>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.esignEnabledBOL}
                            onChange={this.handleSwitchChange("esignEnabledBOL")}
                            value="esignEnabledBOL"
                            classes={{
                              switchBase: classes.switchBase,
                              checked: classes.switchChecked,
                              icon: classes.switchIcon,
                              iconChecked: classes.switchIconChecked,
                              bar: classes.switchBar,
                            }}
                          />
                        }
                        classes={{
                          label: classes.label,
                        }}
                        style={{ marginLeft: "10px" }}
                      />
                    </GridItem>
                    <GridItem
                      xs={12}
                      sm={6}
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      {/* {console.log('CURRENT', this.state)} */}
                      <Button
                        color="primary"
                        onClick={() => {
                          // console.log('KingA', this.state);
                          this.dispatchBOLs();
                        }}
                        disabled={
                          this.state.documentsLoading > 0 &&
                          this.state.documentsLoaded <
                          this.state.documentsLoading
                        }
                      >
                        DISPATCH
                      </Button>
                      {this.state.documentsLoading > 0 ? (
                        [...Array(this.state.documentsLoading).keys()].map(
                          (doc, i) => (
                            <Check
                              style={{
                                color:
                                  this.state.documentsLoaded > i
                                    ? 'limegreen'
                                    : 'initial',
                              }}
                            />
                          )
                        )
                      ) : (
                        <br />
                      )}
                       
                      {this.state.rateConURL && (
                        <a href={this.state.rateConURL} target="_blank">
                          <Button color="info">RATE CON</Button>
                        </a>
                      )}
                      <a
                        href={this.state.esignEnabled ? `https://api.eversign.com/api/download_current_document_status?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${this.state.rateConHash}` : this.state.rateConURL}
                        target="_blank"
                      >
                        <Button color="success">PRINT RATE CON</Button>
                      </a>
                      <a
                        href={`https://api.eversign.com/api/download_current_document_status?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${this.state.rateConHash}`}
                        target="_blank"
                      >
                        <Button color="danger">PRINT OLD RATE CON</Button>
                      </a>
                      <a
                        href={`https://cargo-rx-driver.web.app/pages/trip/${this.props.trip.id}`}
                        target="_blank"
                      >
                        <Button color="info">DRIVER APP MANIFEST</Button>
                      </a>
                    </GridItem>
                    <GridItem xs={12} sm={3}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="status"
                          className={classes.selectLabel}
                        >
                          Status:
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          value={this.state.status}
                          onChange={this.handleSelectChange}
                          inputProps={{
                            id: 'status',
                            name: 'status',
                          }}
                        >
                          {[
                            'Created',
                            'Dispatched',
                            'In Transit',
                            'Completed',
                            'Canceled',
                          ].map((s, i) => (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                              }}
                              value={s}
                              key={i}
                            >
                              {s}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </React.Fragment>
            )}

            <GridContainer justify="flex-end">
              <GridItem xs={12} sm={3} style={{ marginRight: '8px' }}>
                <FormControl
                  fullWidth
                  className={classes.selectFormControl}
                  style={{ paddingRight: '8px' }}
                >
                  <InputLabel
                    htmlFor="tripType"
                    className={classes.selectLabel}
                  >
                    Trip Type:
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    classes={{
                      select: classes.select,
                    }}
                    value={this.state.tripType}
                    onChange={this.handleSelectChange}
                    inputProps={{
                      id: 'tripType',
                      name: 'tripType',
                    }}
                  >
                    {tripTypes.map((type, i) => (
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                        }}
                        value={type}
                        key={i}
                      >
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            <TripVendorForm
              classes={classes}
              vendorSelected={this.state.vendorSelected}
              driverSelected={this.state.driverSelected}
              vendorId={this.state.vendorId}
              driverId={this.state.driverId}
              vendorsData={this.state.vendorsData}
              driversData={this.state.driversData}
              handleVendorChange={this.handleVendorChange}
              handleSelectChange={this.handleSelectChange}
            />
            <GridItem xs={12} md={6}>
              <GridContainer spacing={4}>
                {this.state.selectedOrders.map((order, i, self) => {
                  // console.log("ordercard " + order);
                  const orderRate = () => {
                    // console.log(order, order.rate, i, this.state.tripRate);
                    if (order.rate !== undefined) {
                      return order.rate;
                    } else if (!order.rate && this.state.tripRate) {
                      return parseFloat(this.state.tripRate) / self.length;
                    } else {
                      return 0;
                    }
                  };
                  return (
                    <OrderCard
                      key={order.id}
                      classes={classes}
                      order={order}
                      tripOrder={this.props.trip ? this.props.trip.orders[i] : null}
                      orderQuantity={self.length}
                      orderIndex={i}
                      remove={(e) => this.checkRemoveOrder(e, order)}
                      toggleBOL={(e) => this.toggleBOL(e, i)}
                      handleChangeRate={(e) => this.handleChangeRate(e, i)}
                      handleChangeTripOrderPickUpLocation={(e) => this.handleChangeTripOrderPickUpLocation(e, i)}
                      handleChangeTripOrderDropOffLocation={(e) => this.handleChangeTripOrderDropOffLocation(e, i)}
                      handleDateTimeTripOrderPickUpChange={(e) => this.handleDateTimeTripOrderPickUpChange(e, i)}
                      handleDateTimeTripOrderDropOffChange={(e) => this.handleDateTimeTripOrderDropOffChange(e, i)}
                      handleSwitchChangeOrder={(e) => this.handleSwitchChangeOrder(e, i)}
                      assignBusiness={(...args) => this.assignBusinessTripOrder(...args, i)}
                      handleChangeLegType={(e) => this.handleChangeLegType(e, i)}
                      tripRate={this.state.tripRate !== undefined ? this.state.tripRate : 0}
                      isPickUp={this.state.isPickUp}
                      isDropOff={this.state.isDropOff}
                      pickUpLocation={this.state.pickUpLocation}
                      dropOffLocation={this.state.dropOffLocation}
                      pickUpBy={this.state.pickUpBy}
                      dropOffBy={this.state.dropOffBy}
                      orderRate={orderRate()}
                      rearrangeSelectedOrders={this.rearrangeSelectedOrders}
                      handleClearPickUp={() => this.handleClearPickUp(i)}
                      handleClearDropOff={() => this.handleClearDropOff(i)}
                    />
                  );
                })}
              </GridContainer>
            </GridItem>
            <GridItem xs={12} md={6}>
              <GridContainer justify="space-between" alignItems="center">
                <GridItem xs={6}>
                  Estimated Departure Time:
                  <DateTimePicker
                    onChange={this.handleDepartureTimeChange}
                    value={this.state.estimatedDeparture}
                  />
                </GridItem>
                <GridItem>
                  <Button
                    color="primary"
                    onClick={this.saveTrip}
                    disabled={this.state.isClicked}
                  >
                    {this.props.trip && this.props.trip.orders
                      ? 'UPDATE'
                      : 'CREATE'}{' '}
                    TRIP
                  </Button>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Truck"
                    id="truckType"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      required: true,
                      onChange: (event) => this.handleChange(event),
                      defaultValue: this.state.truckType,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    labelText="Trailer"
                    id="trailerType"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      required: true,
                      onChange: (event) => this.handleChange(event),
                      defaultValue: this.state.trailerType,
                    }}
                  />
                </GridItem>
                <GridItem
                  xs={12}
                  // sm={6}
                  style={{
                    display: 'flex',
                    justifyItems: 'space-around',
                    margin: '16px auto',
                  }}
                >
                  <div style={{ display: 'flex' }}>
                    <b>Alternate Pick Up Location for all orders:</b>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.isPickUp}
                          onChange={this.handleSwitchChange('isPickUp')}
                          value="isPickUp"
                          classes={{
                            switchBase: classes.switchBase,
                            checked: classes.switchChecked,
                            icon: classes.switchIcon,
                            iconChecked: classes.switchIconChecked,
                            bar: classes.switchBar,
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                      }}
                      style={{ marginLeft: '10px' }}
                    />
                  </div>
                  <div style={{ display: 'flex' }}>
                    <b>Alternate Drop Off Location for all orders:</b>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.isDropOff}
                          onChange={this.handleSwitchChange('isDropOff')}
                          value="isDropOff"
                          classes={{
                            switchBase: classes.switchBase,
                            checked: classes.switchChecked,
                            icon: classes.switchIcon,
                            iconChecked: classes.switchIconChecked,
                            bar: classes.switchBar,
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                      }}
                      style={{ marginLeft: '10px' }}
                    />
                  </div>

                  {/* <FormControl>
                                        <FormLabel>
                                            <p>Alternate Address</p>
                                        </FormLabel>
                                        <RadioGroup name='alternateAddress' value={this.state.alternateAddress ? this.state.alternateAddress : ''} onChange={(e) => this.handleItemSelectChange(e)}>
                                            <FormControlLabel value="pickUpLocation" control={<Radio />} label="Pick Up" />
                                            <FormControlLabel value="dropOffLocation" control={<Radio />} label="Drop Off" />

                                        </RadioGroup>
                                    </FormControl> */}
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Description"
                    id="description"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      required: true,
                      onChange: (event) => this.handleChange(event),
                      defaultValue: this.state.description
                        ? this.state.description
                        : this.props.trip
                          ? this.props.trip.description
                            ? this.props.trip.description
                            : '.'
                          : '.',
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Additional Trip Information"
                    id="additionalTI"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      required: true,
                      onChange: (event) => this.handleChange(event),
                      defaultValue: this.state.additionalTI
                        ? this.state.additionalTI
                        : this.props.trip
                          ? this.props.trip.additionalTI
                            ? this.props.trip.additionalTI
                            : '.'
                          : '.',
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <GridContainer justify="space-between">
                    {locationsData
                      .filter((locationObj) => locationObj.isOpen)
                      .map(
                        ({
                          data: locationObj,
                          labels: [camelCase, normalCase],
                          index,
                        }) => (
                          <React.Fragment key={index}>
                            <GridItem xs={12}>
                              <Divider />
                              <GridContainer xs={12}>
                                <GridItem xs={6}>
                                  <p>
                                    <b>{normalCase} Location:</b>
                                  </p>
                                </GridItem>
                                <GridItem xs={6}>
                                  <Button
                                    color="primary"
                                    onClick={() =>
                                      this.handleClearTripAlternate(camelCase)
                                    }
                                  >
                                    CLEAR
                                  </Button>
                                </GridItem>
                              </GridContainer>
                            </GridItem>

                            <GridItem xs={12}>
                              <PrototypeExploreAssignUser
                                labelText={'Search Business Name'}
                                trip={true}
                                collection={'TEST-vendors'}
                                collection2={'TEST-shippers'}
                                id={`${camelCase}Query`}
                                onChange={this.handleChange}
                                value={this.state.entityQuery}
                                assignUser={(...args) =>
                                  this.assignBusiness(...args, camelCase)
                                }
                              />
                              {locationObj && locationObj.entityName && (
                                <p>{locationObj.entityName}</p>
                              )}
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Business Name"
                                id="businessName"
                                formControlProps={{
                                  fullWidth: true,
                                  onChange: this.handleChange,
                                  value:
                                    locationObj && locationObj.businessName
                                      ? locationObj.businessName
                                      : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Address"
                                id="address"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  onChange: (...args) =>
                                    this.handleChangeLocation(
                                      ...args,
                                      camelCase
                                    ),
                                  value:
                                    locationObj && locationObj.address
                                      ? locationObj.address
                                      : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="City"
                                id="city"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  onChange: (...args) =>
                                    this.handleChangeLocation(
                                      ...args,
                                      camelCase
                                    ),
                                  value:
                                    locationObj && locationObj.city
                                      ? locationObj.city
                                      : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="State"
                                id="state"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  onChange: (...args) =>
                                    this.handleChangeLocation(
                                      ...args,
                                      camelCase
                                    ),
                                  value:
                                    locationObj && locationObj.state
                                      ? locationObj.state
                                      : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="Zip"
                                id="zip"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  onChange: (...args) =>
                                    this.handleChangeLocation(
                                      ...args,
                                      camelCase
                                    ),
                                  value:
                                    locationObj && locationObj.zip
                                      ? locationObj.zip
                                      : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              {normalCase} By:
                              <br />
                              <DateTimePicker
                                onChange={(date) =>
                                  this.handleDateTimeChange(
                                    date,
                                    `${camelCase}By`
                                  )
                                }
                                value={this.state[`${camelCase}By`]}
                              />
                              <br />
                              <br />
                            </GridItem>
                          </React.Fragment>
                        )
                      )}
                    {/* var arr = [{x:1},{x:2},{x:4}];

                    arr.reduce(function (a, b) {
                      return {x: a.x + b.x}; // returns object with property x
                    })

                    // ES6
                    arr.reduce((a, b) => ({x: a.x + b.x})); */}

                    <GridItem xs={12}>
                      <b>
                        Total Trip Revenue: $
                        {totalTripRevenue && totalTripRevenue}
                      </b>
                    </GridItem>
                    {/* <GridItem xs={12}><b>Total Trip Expenses: ${totalTripExpenses && totalTripExpenses}</b></GridItem> */}
                    <GridItem xs={12}>
                      <CustomInput
                        labelText="Trip Expense"
                        id="tripRate"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: 'number',
                          required: true,
                          onChange: (event) => this.handleChange(event),
                          defaultValue: this.state.tripRate,
                        }}
                      />
                    </GridItem>
                    {this.state.rateUnallocated ? (
                      <GridItem
                        xs={12}
                        style={{
                          color:
                            this.state.rateUnallocated < 0 ? 'red' : 'black',
                        }}
                      >
                        Unallocated Trip Expense: $
                        {Math.abs(this.state.rateUnallocated).toFixed(2)}
                      </GridItem>
                    ) : null}
                    <GridItem xs={12}>
                      <b>Total Trip CM: ${totalTripCM}</b>
                    </GridItem>
                    <GridItem xs={12}>
                      <b>Total Trip CM%: {totalTripCMPercent}%</b>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12}>
          {this.state.getAll ? null : (
            <Button
              color='primary'
              onClick={this.getAllOrders}
            >
              GET ALL ORDERS
            </Button>
          )}
          <ReactTable
            data={this.state.ordersData}
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            columns={columns.columns}
            defaultPageSize={50}
            defaultSorted={[
              {
                id: 'id',
                desc: false,
              },
            ]}
            //showPaginationTop
            showPaginationBottom
            style={{
              color: '#000',
            }}
            className="-striped -highlight"
          />
          <UserConfirmModal
            isOpen={this.state.promptModal}
            closeModal={() => this.closeModal('promptModal')}
            yesFunc={() => {
              this.addToTrip(selectedOrder, true);
              this.closeModal('promptModal');
            }}
            noFunc={() => {
              this.addToTrip(selectedOrder, false);
              this.closeModal('promptModal');
            }}
          >
            <GridItem xs={12}>
              {/* {console.log("modal log", selectedOrder, this.state)} */}
              <p>
                Order #{selectedOrder && selectedOrder.freightBillNumber}{' '}
                already has a BOL, would you like to generate a new BOL?
              </p>
            </GridItem>
          </UserConfirmModal>
          <UserConfirmModal
            isOpen={this.state.promptDeleteModal}
            closeModal={() => this.closeModal('promptDeleteModal')}
            yesFunc={() => {
              this.removeFromTrip(selectedOrder);
              this.closeModal('promptDeleteModal');
            }}
            noFunc={() => {
              this.closeModal('promptDeleteModal');
            }}
          >
            <GridItem xs={12}>
              <p>
                Order #{selectedOrder && selectedOrder.freightBillNumber} already has set expenses on its register for this trip. Are you sure you want to remove this order from the trip and the trip expense in this order's register?
              </p>
            </GridItem>
          </UserConfirmModal>
        </GridItem>
        <Snackbar
          open={this.state.snackInfo.open}
          autoHideDuration={6000}
          onClose={this.closeSnack}
        >
          <Alert
            onClose={this.closeSnack}
            severity={this.state.snackInfo.severity}
          >
            {this.state.snackInfo.message}
          </Alert>
        </Snackbar>
        {this.state.redirect && <Redirect to="/trips" />}
      </GridContainer>
    ) : (
      <p>Loading...</p>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    assessments: state.assessment,
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(TripBuilder);



// WEBPACK FOOTER //
// ./src/views/Trips/TripBuilder.jsx